/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Indicator/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Indicator({
  children,
  viewPath = "/DesignSystem/TimelineEvent/CustomResource/Content/Title/Indicator"
  
}) {
let dtColorsNeutral200 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.200'
        })
  return (<React.Fragment
>
<div
  data-testid="Indicator.Vertical"
  data-view-path={viewPath}
 className={`views-block ${styles.Vertical}`}
>
<div
  data-testid="Indicator.Vertical:1"
  data-view-path={viewPath}
 style={{'--bc-1-1wiWS0': dtColorsNeutral200}}
 className={`views-block ${styles.Vertical1}`}
/>
</div>
{children}
</React.Fragment>)
}